// extracted by mini-css-extract-plugin
export default {"wrapper":"W_PaymentScenarioPurchaseContent_wrapper__p0wAZ"};